import { WidgetXMLInputConfig } from './WidgetAutoXML.js';
/**
 * {@link WidgetXMLInputConfig} for {@link SingleParent} widgets with a single
 * required child widget parameter.
 *
 * @category XML
 */
export const SingleParentXMLInputConfig: WidgetXMLInputConfig = [
    {
        mode: 'widget',
        name: 'child'
    }
];
